import { Component, inject, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MtxPopoverModule } from '@ng-matero/extensions/popover';
import { FieldWrapper, FormlyFieldConfig, FormlyFieldProps } from '@ngx-formly/core';

interface PopoverProps extends FormlyFieldProps {
  popover: {
    image: string;
    text: string;
    html: string;
  };
}

@Component({
  selector: 'vectronic-formly-popover',
  imports: [MatIcon, MtxPopoverModule],
  template: ` <div class="container">
    <div class="flex">
      <div class="wrapper" #target="mtxPopoverTarget" mtxPopoverTarget>
        <ng-container #fieldComponent></ng-container>
      </div>
      <mat-icon
        [mtxPopoverTriggerFor]="fieldInfo"
        mtxPopoverTriggerOn="click"
        [mtxPopoverTargetAt]="target"
        >help</mat-icon
      >
    </div>
    <mtx-popover #fieldInfo [position]="['above', 'after']">
      @if (html) {
        <div class="popover-content" [innerHTML]="html"></div>
      }
      @if (text) {
        <p>{{ text }}</p>
      }
      @if (imageUrl) {
        <img [src]="imageUrl" />
      }
    </mtx-popover>
  </div>`,
  styles: `
    @use 'variables';
    p,
    .popover-content {
      max-width: 800px;
    }
    .flex {
      display: flex;
      place-items: baseline;
      gap: 0.5rem;
    }
    .wrapper {
      flex: 1;
    }
    .mat-icon {
      color: variables.$vectronic-blue;
      cursor: pointer;
    }
    img {
      max-width: 500px;
    }
  `,
})
export class FormlyPopoverWrapperComponent
  extends FieldWrapper<FormlyFieldConfig<PopoverProps>>
  implements OnInit
{
  html: unknown;
  domSanitizer = inject(DomSanitizer);
  ngOnInit(): void {
    if (!this.props?.popover?.html) return;
    // eslint-disable-next-line sonarjs/no-angular-bypass-sanitization
    this.html = this.domSanitizer.bypassSecurityTrustHtml(this.props.popover.html);
  }
  get imageUrl() {
    return this.props?.popover?.image;
  }

  get text() {
    return this.props?.popover?.text;
  }
}
